var base = {
  box: 'Bus',
  country: 'Land',
  street: 'Straat',
  city: 'Woonplaats',
  optional: 'Optioneel',
  addition: 'Toevoeging',
  postalCode: 'Postcode',
  houseNumber: 'Huisnummer',
  postalCodeIsRequired: 'Postcode is verplicht',
  streetIsRequired: 'Straat is verplicht',
  houseNumberIsRequired: 'Huisnummer is verplicht',
  cityIsRequired: 'Woonplaats is verplicht',
  postalCodeOptionalLabel: 'Gelieve een optie te kiezen uit de voorgestelde lijst',
  postalCodeHouseNumberComboNotFound: 'De postcode en huisnummer combinatie kan niet gevonden worden',
  postalCodeIsNotInDL: 'De opgegeven postcode bevindt zich niet in het levergebied van De Limburger'
};
export default base;